export default __webpack_public_path__ + "static/invimatic-iso-more-news-6-eda5fc7ac249f7213ba7724c8c59d7bc.png";